export function translateUppercaseSetups(upperCaseString) {
  if(upperCaseString === 'ORB') return 'ORB';
  const wordsArr = upperCaseString.split('_');
  let result = '';
  wordsArr.forEach((word) => {
    let newWord = word.slice(0, 1) + word.slice(1).toLowerCase();
    if (word === 'TO') newWord = 'to';
    if (result === '') result = newWord;
    else result = result + ' ' + newWord;
  });
  return result;
}
